<template>
    <div style="display:flex; flex-direction:column; justify-content:center; align-items:center;">
      <Header></Header>
      <HeaderSec Title="云与智能制造" Desc="" :BreadcrumbList="BreadcrumbList"></HeaderSec>
      <Row style="padding:20px;" gutter="24" class="list">
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Image src="https://www.bluehci.com/images001/manufacture001.png" fit="contain" width="270px" height="161px" alt="contain" />
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">新品</Text>
                </Paragraph>
                <Title :level="5">装配类制造数字化</Title>
                <Paragraph>
                  <Text>信息化，数字化，工业智慧，售价  【面议】</Text>
                </Paragraph>
                <Paragraph>
                  <ul>
                      <li>智能制造MON平台</li>
                      <li>
                        WMS、MES、TPM、QMS、APS，智能制造全方位覆盖
                      </li>
                  </ul>
                </Paragraph>
              </Typography>
            </Card>
          </Col>
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Image src="https://www.bluehci.com/images001/manufacture002.png" fit="contain" width="270px" height="161px" alt="contain" />
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">新品</Text>
                </Paragraph>
                <Title :level="5">金属加工类制造数字化</Title>
                <Paragraph>
                  <Text>信息化，数字化，工业智慧，售价  【面议】</Text>
                </Paragraph>
                <Paragraph>
                  <ul>
                      <li>智能制造MON平台</li>
                      <li>
                        WMS、MES、TPM、QMS、APS，智能制造全方位覆盖
                      </li>
                  </ul>
                </Paragraph>
              </Typography>
            </Card>
          </Col>
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Image src="https://www.bluehci.com/images001/manufacture004.png" fit="contain" width="270px" height="161px" alt="contain" />
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">新品</Text>
                </Paragraph>
                <Title :level="5">门窗类工业制造数字化</Title>
                <Paragraph>
                  <Text>信息化，数字化，工业智慧，售价  【面议】</Text>
                </Paragraph>
                <Paragraph>
                  <ul>
                      <li>智能制造MON平台</li>
                      <li>
                        WMS、MES、TPM、QMS、APS，智能制造全方位覆盖
                      </li>
                  </ul>
                </Paragraph>
              </Typography>
            </Card>
          </Col>
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Image src="https://www.bluehci.com/images001/manufacture003.png" fit="contain" width="270px" height="161px" alt="contain" />
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">新品</Text>
                </Paragraph>
                <Title :level="5">化工类制造数字化</Title>
                <Paragraph>
                  <Text>信息化，数字化，工业智慧，售价  【面议】</Text>
                </Paragraph>
                <Paragraph>
                  <ul>
                      <li>智能制造MON平台</li>
                      <li>
                        WMS、MES、TPM、QMS、APS，智能制造全方位覆盖
                      </li>
                  </ul>
                </Paragraph>
              </Typography>
            </Card>
          </Col>
      </Row>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import HeaderSec from '@/components/HeaderSec.vue'
export default {
  name: 'Blueiaas',
  components: {
    Header,
    HeaderSec
  },
  setup() {
  },
  data(){
    return {
      BreadcrumbList: [
        {
            title: '首页',
            to: '/'
        },
        {
            title: '云与智能制造',
        }
      ],
    }
  },
  methods: {
    handleClick() {
      this.$Message.info('Welcome to View UI Plus Demo!')
    }
  }
}
</script>

<style lang="less" scoped>
.list{
  width: 100%;
}
.blueiaas-card{
  background-color:#f2f2f2;
  margin-top: 20px;
}
@media (min-width: 1000px) {
  .list{
    width: 1600px;
  }
  .blueiaas-card{
    background-color:#f2f2f2;
    margin-top: 20px;
  }
}
</style>
